if (!customElements.get('oadsy-free-shipping')) {
  class OadsyFreeShipping extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10);
      this.progressEl = this.querySelector('.oadsy-free-shipping__progress');
      this.doneEl = this.querySelector('.oadsy-free-shipping__done');
      this.fillEl = this.querySelector('.oadsy-free-shipping__fill');
      this.remainingEl = this.querySelector('.oadsy-free-shipping__remaining');

      // Animate from last known width — persists across DOM replacements so re-mounts transition instead of jump.
      if (this.fillEl) {
        const oldWidth = window.__oadsyFillWidth ?? 0;
        const targetWidth = parseFloat(this.fillEl.style.width) || 0;
        if (targetWidth !== oldWidth) {
          this.fillEl.style.transition = 'none';
          this.fillEl.style.width = oldWidth + '%';
          this.fillEl.offsetWidth; // force reflow
          this.fillEl.style.transition = '';
          this.fillEl.style.width = targetWidth + '%';
        }
        window.__oadsyFillWidth = targetWidth;
      }

      if (typeof subscribe === 'function') {
        this._unsubscribe = subscribe('cart-update', (data) => this._onCartUpdate(data));
      }
    }

    disconnectedCallback() {
      if (this._unsubscribe) this._unsubscribe();
    }

    _onCartUpdate(data) {
      // Dawn publishes cartData (from /cart/change.js response) which contains total_price in cents
      const total = data?.cartData?.total_price ?? data?.cart?.total_price;
      if (total !== undefined) {
        this._update(total);
      } else {
        this._fetchAndUpdate();
      }
    }

    async _fetchAndUpdate() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        this._update(cart.total_price);
      } catch (e) {
        // fail silently — server-rendered state is still correct
      }
    }

    _update(totalCents) {
      if (totalCents >= this.threshold) {
        this.progressEl?.setAttribute('hidden', '');
        this.doneEl?.removeAttribute('hidden');
      } else {
        const remaining = this.threshold - totalCents;
        const pct = Math.min(100, (totalCents / this.threshold) * 100);

        if (this.remainingEl) {
          this.remainingEl.textContent = this._formatMoney(remaining);
        }
        if (this.fillEl) {
          this.fillEl.style.width = `${pct}%`;
          window.__oadsyFillWidth = pct;
        }

        this.progressEl?.removeAttribute('hidden');
        this.doneEl?.setAttribute('hidden', '');
      }
    }

    _formatMoney(cents) {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    }
  }

  customElements.define('oadsy-free-shipping', OadsyFreeShipping);
}
